import { Box } from '@mui/material'
import AtlasImageurl from '../../../../assets/images/Atlas.png'
import RcmLogoIcon from '../../../../shared/icons/RcmLogoIcon'
import RcmGlobalFamilyTextIcon from '../../../../shared/icons/RcmGlobalFamilyTextIcon'

const RcmLoginBackground = () => {
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.primary.main,
        width: '100%',
        height: '100%',
        position: 'relative'
      }}
      component="div"
    >
      <Box
        sx={{
          opacity: 0.1,
          height: `70%`,
          width: `70%`,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
        aria-label="Rockefeller Digital Client Login"
        tabIndex={0}
      >
        <img
          src={AtlasImageurl}
          alt="Rockefeller Digital Client Login"
          style={{ objectFit: 'contain', height: '100%', width: '100%' }}
          aria-hidden={false}
        />
      </Box>
      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -75%)' }}>
        <RcmGlobalFamilyTextIcon sx={{ fontSize: { xs: '250px', md: '300px', lg: '400px', xl: '420px' } }} />
      </Box>
      <Box sx={{ position: 'absolute', bottom: '10px', right: '20px', opacity: 0.8 }}>
        <RcmLogoIcon
          sx={{ fontSize: { xs: '20px', md: '70px', lg: '100px' }, fill: (theme) => theme.palette.common.white }}
        />
      </Box>
    </Box>
  )
}

export default RcmLoginBackground
